module.exports = __webpack_public_path__ + "static/media/Equal-Play-Study-GER.0592b161.pdf";